import React from 'react';
import BootstrapCard from 'react-bootstrap/Card';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './Card.module.css';

const Card = (props) => {
    return (
        <BootstrapCard className={cn(styles.card, props.className)}>{props.children}</BootstrapCard>
    );
};

Card.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};

export default Card;
